import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import React, { useCallback } from 'react';

type Props = {
	onEditClick: () => void;
	onDeleteClick: () => void;
};

const ActionableNodeTitleMenu = ({ onEditClick, onDeleteClick }: Props) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const editClick = useCallback(() => {
		setAnchorEl(null);
		onEditClick();
	}, [onEditClick, setAnchorEl]);

	return (
		<Box
			sx={{
				cursor: 'pointer'
			}}
			width={20}
			height={20}
			flexGrow={1}
			textAlign="right"
			display="flex"
			justifyContent="flex-end"
		>
			<IconButton
				data-testid="node-options-button"
				aria-label={intl.tr('button.options')}
				aria-controls={open ? 'node-options-menu' : undefined}
				aria-haspopup="true"
				sx={{ width: 20 }}
				aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
			>
				<MoreVertIcon />
			</IconButton>
			<Menu
				id="node-options-menu"
				aria-labelledby="node-options-button"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left'
				}}
				sx={{
					'& .MuiPaper-root': {
						minWidth: 140
					}
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left'
				}}
			>
				<MenuItem onClick={editClick} data-testid="edit-flow-node-button">
					<EditIcon sx={{ mr: 2 }} />
					{intl.tr('button.edit')}
				</MenuItem>
				<MenuItem onClick={onDeleteClick} data-testid="delete-flow-node-button">
					<DeleteForeverIcon sx={{ mr: 2 }} />
					{intl.tr('button.delete')}
				</MenuItem>
			</Menu>
		</Box>
	);
};

export default ActionableNodeTitleMenu;
